export type Constructable<T extends any> = { new(...args: any): T }

/**
 * @deprecated legacy
 */
export abstract class BaseModel {
  takeChanged(fields: Partial<this>): this {
    const newFields = Object.assign({ ...this }, fields);
    return new (this.constructor as Constructable<any>)(...Object.values(newFields));
  }
}
